export default {
    // NauticSpot
    Trans: {
        ok: 'OK',
        beginning: 'Inizio',
        cost: 'Costo',
        date: 'Fecha',
        day: 'giorno',
        week: 'settimana',
        month: 'mese',
        days: 'giorni',
        description: 'Descrizione',
        delete: 'Rimuovere',
        'delete.confirm': 'Está usted seguro de borrar?',
        download: 'Scaricare',
        end: 'Fine',
        edit: 'Cambiamento',
        save: 'Registrare',
        saved: 'Salvado',
        send: 'Mandare',
        cancel: 'Annullare',
        total: 'Totale',
        notFound: 'Ninguno',
        emptyText: 'Sin datos',
        back: 'Regroso',
        close: 'Chiudere',
        map: 'Mapa',
        'map.stroke': 'Mapa de contorno',
        search: 'Buscar',
        at: 'a',
        loading: 'Cargando',

        mister: 'Signore',
        miss: 'Sig.ra',

        facebook: 'Facebook',
        linkedin: 'Linkedin',
        twitter: 'Twitter',

        matin: 'Mattina',
        apresmidi: 'Pomeriggio',
        refused: 'Rfiutato',
        approved: 'Accettato',
        requested: 'In attesa di',
        accepted: 'Accettato',

        monday: 'Lunedi',
        tuesday: 'Martedì',
        wednesday: 'Mercoledì',
        thursday: 'Giovedi',
        friday: 'Venerdì',
        saturday: 'Sabato',
        sunday: 'Domenica',

        welcome: 'Buongiorno __USER__',

        locale: {
            fr: 'Français',
            en: 'English',
            es: 'Español',
            it: 'Italiano',
        },

        stats: 'Estadísticas',
        drag_drop_invitation:
            'Haga clic o suelte un archivo aquí para cargarlo.',

        pages: {
            home: 'Acogida',
            users: 'Navegantes',
            calendar: 'Calendario',
            map: 'Papa del puerto',
            rates: 'Precios',
            reporting: 'Reporting',
            profile: 'Mi perfil',
            configuration: 'Configuracion',
            security: 'Seguridad',
            communication: 'Comunicación',
        },

        communication: {
            weather_upload: {
                success: 'El boletín ha sido actualizado',
                failed:
                    'Se produjo un error, el boletín no se pudo actualizar.',
            },
            notification: {
                _: 'Notificaciones - Histórico',
                duplicate: 'Duplicar',
                edit: {
                    title: 'Edit',
                    success: 'Notification updated'
                },
                notify: 'Notificar a los navegantes',
                title: 'Ingrese el título del mensaje ...',
                content: 'Detalla el mensaje ...',
                url: 'Rellene un enlace (opcional)',
                link: 'Enlace',
                selectCategory: 'Seleccione una categoria',
                selectHarbour: 'Seleccione un porta',
                sentAt: 'Enviado el',
                showDetails: 'Ver detalles',
                details: 'Detalles',
                attachments: 'Documento(s) adjunto(s)',
                thumbnail: 'Imagen de vista',
                selectThumbnail: 'Selecciona una imagen',
                recipients: {
                    _: 'Destinatairio',
                    all: 'Tutti',
                    'user-lists': 'Lista di distribuzione',
                    pontoon: 'Pontoni',
                    users: 'Diportisti',
                },
                type: {
                    weather: 'Clima',
                    security: 'Seguridad',
                    event: 'Evento',
                    work: 'Obras / Mantenimiento',
                    'concierge-package': 'Conserjería - Paquetes',
                    'concierge-mail': 'Conserjería - Correo',
                    news: 'Actualidaded',
                    other: 'Otros',
                },
                success: 'La notificación ha sido enviada',
                failure:
                    'No se puede enviar la notificación, se produjo un error',
                delete: {
                    success: 'Notification deleted',
                },
                deleteAttachment: {
                    success: 'Attachment deleted'
                }
            },
            communication: 'Comunicación',
        },

        months: {
            jan: 'Gennaio',
            feb: 'Febbraio',
            mar: 'Marzo',
            apr: 'Aprile',
            may: 'Maggio',
            jun: 'Giugno',
            jul: 'Luglio',
            aug: 'Agosto',
            sep: 'Settembre',
            oct: 'Ottobre',
            nov: 'Novembre',
            dec: 'Dicembre',
        },
        'days.short': {
            monday: 'Lun',
            tuesday: 'Mar',
            wednesday: 'Mer',
            thursday: 'Gio',
            friday: 'Ven',
            saturday: 'Sab',
            sunday: 'Dom',
        },
        calendar: {
            max: 'Max : ',
            mean: 'Moy : ',
            min: 'Min : ',
            days: {
                long: {
                    monday: 'Lunedi',
                    tuesday: 'Martedì',
                    wednesday: 'Mercoledì',
                    thursday: 'Giovedi',
                    friday: 'Venerdì',
                    saturday: 'Sabato',
                    sunday: 'Domenica',
                },
                short: {
                    monday: 'Lun',
                    tuesday: 'Mar',
                    wednesday: 'Mer',
                    thursday: 'Gio',
                    friday: 'Ven',
                    saturday: 'Sab',
                    sunday: 'Dom',
                },
            },
            months: {
                long: {
                    jan: 'Gennaio',
                    feb: 'Febbraio',
                    mar: 'Marzo',
                    apr: 'Aprile',
                    may: 'Maggio',
                    jun: 'Giugno',
                    jul: 'Luglio',
                    aug: 'Agosto',
                    sep: 'Settembre',
                    oct: 'Ottobre',
                    nov: 'Novembre',
                    dec: 'Dicembre',
                },
                short: {
                    jan: 'Gen',
                    feb: 'Feb',
                    mar: 'Mar',
                    apr: 'Apr',
                    may: 'Mag',
                    jun: 'Giu',
                    jul: 'Lug',
                    aug: 'Ago',
                    sep: 'Set',
                    oct: 'Ott',
                    nov: 'Nov',
                    dec: 'Dic',
                },
            },
        },

        license:
            'Nauticspot tutti i diritti riservati © 2018 Creato da IAS Ingénierie',

        address: {
            title: 'Indirizzo',
            street: 'Strada',
            country: 'Paese',
            city: 'Città',
            postalCode: 'Codice postale',
        },
        error_message: 'È verificato un errore',
        error: {
            required: 'Grazie di compilare questo campo',
            'email.invalid': 'Chiedi un indirizzo email valido',
            'phone.invalid': 'Numero di telefono non valido',
        },

        advancedSearch: {
            show: 'Filtri avanzati',
            hide: 'Nascondi i filtri',
        },
        'auth.error.invalidCredentials': 'Nombre o contraseña incorrectos',
        login: {
            username: 'Nombre del usuario',
            password: 'Password',
            rememberMe: 'Ricordati di mei',

            'logIn.button': 'Entra',
            'logOut.button': 'Esci',
            'username.error.required': 'Inserisci il tuo login',
            'password.error.required': 'Si prega di inserire la password',
            'password.forgotten': 'Olvidé mi contraseña',
        },
        password_forgotten: {
            title: 'Contraseña olvidada',
            resetPassword: 'Modificare la mia password',
            confirm:
                'Un e-mail è stata inviata a voi per cambiare la password.',
        },
        accessRequest: {
            title: 'Richieste di collegamento in corso',
            user: 'Utente',
            category: 'Categoria',
            place: 'Ubicazione',
            boat: 'Nave',
            refusalComment: 'Motivi di rifiuto',
            refusal: {
                title: 'Refiutare la richiesta',
                success: 'Richiesta rifiutato',
            },

            approval: {
                title: 'Accettare la richiesta',
                existingBoat: 'Nave esistente',
                newBoat: 'Nuova nave',
                success: 'Richiesta è stata accettata',
            },
            categories: {
                yachtsman: 'Navegante',
                professional: 'Profesional',
                visitor: 'Visitatore',
            },
        },
        user: {
            firstName: 'Conome',
            lastName: 'Nome',
            name: 'Nome',
            role: 'Papel',
            roles: 'Papeles',
            username: 'Accesso',
            nationality: 'Nazionalità',
            locale: 'Lengua',
            email: 'eMail',
            boats: 'Barche',
            phoneNumber: 'N° Telefono',
            'password.edit.title': 'Modifica password',
            password: 'Password',
            passwordConfirm: 'Conferma',
            'password.error.required': 'Si prega di inserire la password',
            error: {
                emailAlreadyUsed: 'Este correo electrónico ya está en uso',
                usernameAlreadyUsed: 'Este identificador ya está en uso',
            },

            creation: {
                title: 'Agregar usuario',
                success: 'Usuario "__name__" creado',
            },
            update: {
                title: 'Editar usuario',
                success: 'Usuario "__name__" editado',
            },
            delete: {
                success: 'Usuario borrado',
                error: 'Usuario borrado errore',
            },
        },
        role: {
            administrator: 'Administrador',
            yachtsman: 'Navegante',
            security_officer: 'Agente de seguridad',
            captain: 'Capitanía',
            professional: 'Profesional',
            surveyor: 'Supervisor',
            visitor: 'Cisitatore',
            super_admin: 'Super Admin',
            'any.role.nauticspot': 'Otro',
        },
        yachtsman: {
            creation: {
                title: 'Agregar un navegante',
                success: 'Navegante "__name__" creado',
            },
            update: {
                title: 'Editar un navegante',
                success: 'Navegante "__name__" editado',
            },
        },

        weather: {
            forecast: {
                _: 'Boletín meteorológico',
                upload: 'Actualizar el boletín',
                download: 'Ver el boletín en línea',
                updated: 'Última actualización: __date__',
                close_preview: 'Cerrar',
            },
        },
        absence: {
            absence: 'Ausencia',
            absences: 'Ausencias',
            departureDate: 'Fecha de salida',
            returnDate: 'Fecha de regreso',
            anticipatedReturnDate: 'Fecha de regreso anticipado',
            place: 'Amarre',
            boat: 'Barco',
            owners: 'Navegante',
            legend: {
                pending: 'Esperando',
                approved: 'Disponible',
                present: 'Occupado',
                'anticipated-return': 'Regreso Anticipado',
            },
            creation: {
                title: 'Nuova assenza',
                success: 'Assenza dichiarato',
            },
            anticipatedReturn: {
                creation: {
                    title: 'Agregar un Regreso Anticipado',
                    success: 'Regreso Anticipado creado',
                },
            },
        },
        multihull: 'Multiscafo',
        sailboat: 'Yacht',
        motorboat: 'Motore',
        resident: 'Résidente',
        stopover: 'Arresto',
        commitment: {
            user: 'Nombre',
            startDate: 'Inicio',
            endDate: 'Fin',
            unknown: 'Desconocido',
            inProgress: 'En curso',

            disengage: 'Retirar',
            engage: 'Contratame',
            showHistory: 'Ver historial',
            userTypes: {
                agent: 'Agente',
                supervisor: 'Supervisor',
            },
            confirmModal: {
                title: '¿De verdad quieres involucrarte?',
                content:
                    'Si te comprometes, no puedes volver atrás.\nSolo otro usuario tendrá que comprometerse a su vez para liberarlo.',
            },
            disconfirmModal: {
                title: '¿Estás seguro de que deseas optar por no participar?',
                content: ' ',
            },
            historyModal: {
                title: 'Historia de compromisos',
            },
        },
        boat: {
            _: 'Bateau',
            name: 'Nome',
            boatType: 'Tipo',
            place: 'Posto',
            draught: 'Profondità',
            length: 'Lunghezza',
            width: 'Larghezza',
            size: 'Formato',
            immatriculation: 'Registrazione',
            hasTank: 'Serbatoio acqua reflua',
            owners: 'Proprietari',
            position: 'Posizione',
            countAbsences: 'Numero di assenze',
            countOutings: 'Numero di uscite',
            synoxDeviceId: 'N° Box Synox',
            creation: {
                title: 'Agregar un Barco',
                success: 'Barco "__name__" creado',
            },
            update: {
                title: 'Editar un Barco',
                success: 'Barco "__name__" editado',
            },
            delete: {
                success: 'Barco borrado',
                error: 'Barco borrado errore',
            },
            categories: 'Categorías de barcos',
            category: {
                name: 'Nombre',
                length: 'Largo',
                width: 'Ancho',
                minLength: 'Largo Min',
                maxLength: 'Largo Max',
                minWidth: 'Ancho Min',
                maxWidth: 'Ancho Max',
                definition: 'De __min__m hasta __max__m',
                definition_min: 'Más de __min__m',
                definition_max: 'Hasta __max__m',
                definition_undefined: 'No-definido',
                other: {
                    description: 'Fuera de categoría',
                },
                creation: {
                    title: 'Agregar una categoría.',
                    success: 'Categoría agregada.',
                },
                update: {
                    title: 'Editar una categoría.',
                    success: 'Categoría editada.',
                },
            },
        },
        configuration: {
            informations: 'Informaciones',
            photo_updated: 'Imagen actualizada',
            upload_failed: 'Error al cargar el archivo.',
            photo_update: 'Editar logo',
            map_updated: 'Mapa actualizado',
            map_update: 'Editar el mapa',
            import_users: 'Importar usuarios',
            import_users_success: 'Importación terminada',
            security: 'Módulo de seguridad',
            absence: 'Módulo de ausencia',
            port: 'Puerto',
            miscellanous: 'Informazioni pratiche',
        },
        partners: 'Servicios',
        'external-links': 'Link esterno',
        externalLink: {
            name: 'Formulazione',
            color: 'Colore',
            noBackground: 'Lineamenti',
            url: 'URL',
            updateIcon: "Cambia icona",
            create: {
                title: 'Aggiungi un collegamento',
                success: 'Collegamenti aggiornati',
                error: "Non in grado di salvare",
            },
        },
        partner: {
            name: 'Nom',
            type: 'Catégorie',
            description: 'Description',
            email: 'Email',
            phone: 'Téléphone',
            websites: 'Sites internet',
            website: {
                label: 'Libellé',
                add: 'Ajouter un site internet',
            },
            types: {
                'harbour-office': 'Capitaneria',
                maintenance: 'Manutenzionee',
                restaurant: 'Ristorante',
                'nautic-activity': 'Attività nauticav',
                association: 'Associazione',
                health: 'Salute',

                'activity-culture': 'Cultura',
                'activity-entertainment': 'Divertimento',
                'activity-nature': 'Natura',
                'activity-other': 'Altro',

                'shop-food': 'Alimentazione',
                'shop-tools': 'Fai da te - Utensili',
                'shop-nautic-tools': 'Attrezzi nautici',
            },
            hours: 'Horaires',
            miscellanous: 'Informazioni pratiche',
            thumbnail: 'Logo',
            pictures: 'Photos',
            picture: {
                add: {
                    title: 'Ajouter une photo',
                    error: 'Impossible de télécharger la photo',
                },
            },
            update: {
                title: 'Modifier un partenaire',
                success: 'Partenaire modifié',
            },
            creation: {
                title: 'Ajouter un partenaire',
                success: 'Partenaire créé',
            },
            delete: {
                error: 'Erreur lors de la suppression',
                success: 'Partenaire supprimé',
            },
        },
        markdown: {
            link: 'Para crear un enlace: [nombre del enlace] (dirección URL)',
            h1: 'Para crear un titulo: # Título del título',
            italic: 'Para poner en cursiva: _texto_',
            preview: 'Vista previa',
            help: 'Ayuda',
        },
        places: 'Amarres',
        place: {
            _: 'Place',
            code: 'Codice',
            boatTypes: 'Navi autorizzate',
            placeType: 'Sala da pranzo',
            boat: 'Barca',
            length: 'Lunghezza',
            width: 'Larghezza',
            draught: 'Profondità',
            pontoon: 'Pontón',

            deviceId: 'N° Sensor Pontón',
            ultrasonicMinThreshold: 'Umbral min',
            ultrasonicMaxThreshold: 'Umbral max',
            minInFrameThreshold: 'Nb trames retour',
            minOutFrameThreshold: 'Nb trames sortie',

            deviceType: 'Type',
            deviceTypes: {
                buoy: 'Buoy',
                pontoon: 'Pontoon'
            },

            creation: {
                title: 'Agregar un amarre',
                success: 'Amarre creado',
                draw: 'Dibuja el área para definir',
            },
            update: {
                title: 'Modificar un amarre',
                success: 'Amarre modificado',
            },
            deletion: {
                title:
                    '¿Estás seguro de que deseas eliminar el amarre "__name__"?',
                content:
                    'Esta acción solo borrará el dibujo del área en el mapa y no el amarre vinculado a él.',
                success: 'Amarre borrado',
                select: 'Seleccione el área para borrar',
            },
            state: {
                occupied: 'Amarre ocupado',
                in: 'Amarre ocupado',
                out: 'Amarre vacio',
                absence: 'Amarre disponible',
                empty: 'Amarre vacio',
                available: 'Amarre disponible',
                stopover: 'Escala',
                error: 'Error sensor',
            },
            error: {
                notFound: 'El amarre solicitado no existe.',
            },
        },
        pontoons: 'Pontones',
        pontoon: {
            name: 'Codigo',
            places: 'Amarres',
            creation: {
                title: 'Agregar un pontón',
                success: 'Pontón creado',
            },
            update: {
                title: 'Modificar un pontón',
                success: 'Pontón modificado',
            },
        },
        'notification-user-lists': 'Listas de correo',
        'notification-user-list': {
            name: 'Nombre',
            users: 'Usarios',
            creation: {
                title: 'Agregar una lista de correo',
                success: 'Lista creada',
            },
            update: {
                title: 'Modificar una lista de correo',
                success: 'Lista modificada',
            },
        },
        'weather-api': 'Stazione meteorologica',
        mapShape: {
            update: {
                success: 'Map shape updated',
                error: 'Map shape update error',
            },
            deletion: {
                title: '¿Estás seguro de que deseas borrar la forma?',
                content:
                    'Esta acción borrará solo la forma seleccionada y no el resto del mapa.',
                success: 'Forma borrada',
                select: 'Seleccione la forma para borrar',
            },
        },
        mapPosition: {
            name: 'Nombre',
            isDefault: 'Posición por defecto',
            isPublic: 'Cuenca visible para todos los usuarios',
            save: {
                success: 'Posición registrada',
            },
            delete: {
                success: 'Posición borrada',
            },

            label: 'Cuencas',
            saveBtn: {
                tooltip: 'Establecer como posición / zoom de la cuenca',
            },
            defaultBtn: {
                tooltip: 'Establecer como cuenca predeterminada del puerto',
            },

            createModal: {
                title: 'Agregar una cuenca',
                success: 'Cuenca creada',
                error: 'No se puede crear la cuenca',
            },
            createBtn: {
                title: 'Agregar una cuenca',
            },
        },
        editPanel: {
            zone: 'Zona',
            place: 'Amarre',
            shape: 'Forma',

            calques: 'Capas',
            actions: 'Acciones',
        },
        zone: {
            zone: 'Zona',
            name: 'Nombre',
            creation: {
                title: 'Agregar una Zona',
                success: 'Zona creada',
                choice: '¿Quieres crear una zona o un amarre?',
            },
            update: {
                title: 'Modificar una zona',
                success: 'Zona modificada.',
                message: 'Seleccionar la zona para editar',
                bad_zone: 'La zona que seleccionaste es un amarre.',
                bad_zone_description:
                    ' Un amarre no se puede cambiar de esta manera en este momento. Vaya a "configuración" para modificar sus amarres.',
            },
            deletion: {
                title: '¿Estás seguro de que deseas borrar la zona "__name__"?',
            },
            error: {
                notFound: 'La zona solicitada no existe',
            },
        },
        position: {
            in: 'Al Puerto',
            out: 'En Mar',
        },
        rate: {
            category: 'Categoria',
            name: 'Codice',
            boatTypes: 'Tipi di barca',
            season: {
                high: 'Temporada alta',
                low: 'Temporada baja',
                off: 'Fuera de temporada',
                definition: 'De __start__ hasta __end__',
                from: 'De',
                to: 'hasta',
                update: {
                    success: 'Stagione modificada',
                },
            },
            creation: {
                title: 'Crear una tarifa',
                success: 'Tarifa creada',
            },
            update: {
                title: 'Modificar una tarifa',
                success: 'Tarifa modificada',
            },
        },
        harbour: {
            name: 'Nombre',
            latitude: 'Latitud',
            longitude: 'Longitud',
            address: 'Dirección',
            phone: 'Téléfono',
            fax: 'Fax',
            email: 'Email',
            defaultLocale: 'Lengua',
            country: 'Paese',
            absenceEmail:
                'Correo electrónico utilizado para notificar una solicitud de ausencia',
            securityEmail:
                'Correo electrónico utilizado para informar un nuevo incidente',
            commitmentEmail:
                'Correo electrónico utilizado para notificar un cambio de compromiso',
            minutesBeforeEmail: 'Minutos antes notificación',
            intervalMinutesBetweenMail: 'Minutos entre notificación',
            select: 'Seleccione un puerto',
            change: 'Cambiar puerto',
            update: {
                success: 'Puerto "__name__" modificado',
            },
            hourBeginDay: 'Hora de inicio del día',
            hourEndDay: 'Hora del fin del día',
        },
        cameras: 'Telecamere',
        information: 'Informaciones',
        season: 'Stagione',
        camera: {
            name: 'Nombre',
            url: 'URL',
            type: 'Tipo',
            creation: {
                title: 'Agregar una camara',
                success: 'Camara creada',
            },
            update: {
                title: 'Modificar una camara',
                success: 'Camara modificada',
            },
            delete: {
                success: 'Camara borrada',
            },
            types: {
                playlist: 'Fichier vidéo',
                iframe: 'Lecteur Web',
            },
        },
        reporting: {
            main: 'General',
            repartition: 'Salidas por hora',
            outing: 'Salidas',
            outing_history: 'Salidas',
            calendar: 'Calendario',
            outing_by_type: 'Salidas para tipo de barco',
            fill_history: 'Historia de llenado',
            top_10: 'Top navegantes',
            mean: 'Medio',
            potential: 'Potencial',
            filters: {
                title: 'Filtres',
                labels: {
                    period_title: 'Periodo',
                    period: 'Período durante el cual ver informes',
                    compare: 'Comparar con :',
                    users: 'Navegantes',
                    places_zones: 'Amarre / Zona',
                    places: 'Amarres',
                    zones: 'Zonas',
                    types: 'Tipo de barcos :',
                    category: 'Categoría de barco',
                },
                date: 'Por favor seleccione un dato valido',
                year: 'Por favor seleccione un año',
            },
            top10: {
                number_outing: 'Número de salidas sobre el periodo',
                by_day: 'Salidas Día',
                by_night: 'Salidas Cruceras',
                relative_night: '% de salidas de ncoche',
                title_less: 'Usarios les menos activos',
                title_most: 'Usarios les más activos',
            },
            occupancy: {
                title: 'Llenado',
                evolution: '__EVOLUTION__% comparé à __DATE__',
                no_evolution: 'sin evolución en comparación con __DATE__',
                places: '__NB__ amarres',
                placesUsed: 'Amarres ocupados',
                placesEmpty: 'Amarres vacios',
            },
            data: {
                waiting: 'Esperando datos.',
                no_data: 'Sin datos recibidos.',
                waiting_explanation:
                    'No se han recibido datos hasta el momento.',
                no_data_explanation:
                    'Parece que no hay datos disponibles en este período para este gráfico.',
            },
            optimisation: {
                title: 'Optimización',
                tableTitle: {
                    period: 'Periodos',
                    nights: 'Salidas',
                    profit: 'Ganancias',
                    absences: 'Ausencias',
                    losts: 'Pérdidas',
                },
                period: 'Desde __start__ hasta __end__',
                profit: {
                    potential: 'Potencial',
                    realised: 'Realisado',
                    lost: 'Pérdidas',
                },
                outings: 'Salidas en mar',
                optimized: 'Optimizadas en escala',
                declared: 'Declaradas',
                outside: 'Excluyendo puerto de origen',
            },
        },
        outing: {
            timeIn: 'Hora de llegada',
            timeOut: 'Hora de salida',
            listByDay: 'Lista de salidas el __date__',
        },
        urgencePhoneNumbers: 'Números de emergencia',
        urgencePhoneNumber: {
            name: 'Nombre',
            phoneNumber: 'Tel.',
            vhf: 'VHF',
            creation: {
                title: 'Agregar un número de emergencia',
                success: 'Número creado',
                btn: 'Agregar un núméro de emergencia',
            },
            update: {
                title: 'Modificar un núméro de emergencia',
                success: 'Número modificado',
            },
            delete: {
                success: 'Número borrado',
            },
        },
        users: 'Usarios',
        categories: 'Categorias',

        incidents: 'Incidentes',
        incident: {
            name: 'Incidente',
            user: 'Paglietta',
            types: {
                fire: 'Fuoco',
                sink: 'Lavello',
                theft: 'Furto',
                electric: 'Problema elettrico',
                water: 'Perdite',
                sound: 'Inquinamento acustico',
                other: 'Altro',
                polution: 'Inquinamento',
                lighting: 'Illuminazione',
                broken_board: 'Tabla quabrada',
                collision: 'Choque',
                harbour_map: 'Mapa del porto',
                sanitary: 'Sanitario',
                extinguisher: 'Estintore',
                chain: 'Catena',
                ladder: 'Scala',
                towing: 'Traino',
                mooring: 'Ormeggio',
            },
            visibility: {
                _: 'Visibilità',
                none: 'Nessuno',
                captain: 'Porto ufficio',
                all: 'Tutti'
            },
            type: {
                _: "Type d'incident",
                fire: 'Fuoco',
                sink: 'Lavello',
                theft: 'Furto',
                electric: 'Problema elettrico',
                water: 'Perdite',
                sound: 'Inquinamento acustico',
                other: 'Altro',
                polution: 'Inquinamento',
                lighting: 'Illuminazione',
                broken_board: 'Tabla quabrada',
                collision: 'Choque',
                harbour_map: 'Mapa del porto',
                sanitary: 'Sanitario',
                extinguisher: 'Estintore',
                chain: 'Catena',
                ladder: 'Scala',
                towing: 'Traino',
                mooring: 'Ormeggio',
            },
            comment: 'Patrón',
            comments: 'Commento',
            harbourComment: 'Comentario del puerto',
            saveHarbourComment: 'Registrar el comentario',
            status: 'Estado',
            zone: 'Zona',
            createdAt: 'Data',
            confirmedByOne: 'Confermato da un navigante',
            confirmedBy: 'Confermato da __count__ diportisti',
            acknowlegedAt: 'Teniendo en cuenta el __DATE__',
            acknowlegedAt_by: 'Teniendo en cuenta el __DATE__ por __USER__',
            closedAt: 'Cerrado el __DATE__',
            closedAt_by: 'Cerrado el __DATE__ por __USER__',
            attachments: 'Allegati',
            no_attachment: 'Nessun allegato',
            createdBy: 'Creato da',
            security: 'Seguridad',
            safety: 'Seguridad',
            maintenance: 'Manutenzione',
            email: 'Emails de notificación',
            notificationEmail:
                'Email utilizado para notificar un nuevo incidente',
            isCritical: 'Critico',
            criticalPhoneNumber: {
                day: 'Telefono de emergencia (día)',
                night: 'Telefono de emergencia (noche)',
            },
            editZone: 'Definir la zona',
            statuses: {
                pending: 'In attesa di',
                acknowledged: 'Riconosciuto',
                closed: 'Chiuso',
            },
            action: {
                acknowledge: 'Tener en cuenta el incidente.',
                close: 'Cerrar el incident',
            },

            pendingIncidents: 'Incidente segnalato',

            creation: {
                title: 'Dichiarare un incidente',
                success: 'Incidente segnalato',
            },
            update: {
                success: 'Incidente modificati',
            },
        },
    },

    // Ant Design
    Table: {
        filterTitle: 'Ricercare...',
        filterConfirm: 'Bene',
        filterReset: 'Ripristina',
        emptyText: 'Non ci sono dati',
    },
    Modal: {
        okText: 'Bene',
        cancelText: 'Annullare',
        justOkText: 'Bene',
    },
    Popconfirm: {
        okText: 'Bene',
        cancelText: 'Annullare',
    },
    Transfer: {
        notFoundContent: 'Nessun risultato',
        searchPlaceholder: 'Ricerca',
        itemUnit: 'elemento',
        itemsUnit: 'articoli',
    },
    Select: {
        notFoundContent: 'Nessun risultato',
    },
    Pagination: {
        // Options.jsx
        items_per_page: '/ pagina',
        jump_to: 'Andare a',
        page: '',

        // Pagination.jsx
        prev_page: 'Pagina Precedente',
        next_page: 'Pagina Successiva',
        prev_5: '5 Previo Pagine',
        next_5: '5 Pagina Successiva',
        prev_3: '3 Previo Pagine',
        next_3: '3 Pagina Successiva',
    },
    TimePicker: {
        placeholder: '',
    },
    DatePicker: {
        lang: {
            today: 'Oggi',
            now: 'Adesso',
            backToToday: 'Torna a oggi',
            ok: 'Bene',
            clear: 'Svuotare',
            month: 'Mese',
            year: 'Anno',
            timeSelect: "Selezionare l'ora",
            dateSelect: 'Selezionare una data',
            monthSelect: 'Seleziona un mese',
            yearSelect: 'Seleziona Anno',
            decadeSelect: 'Selezionare un decennio',
            yearFormat: 'YYYY',
            dateFormat: 'M/D/YYYY',
            dayFormat: 'D',
            dateTimeFormat: 'M/D/YYYY HH:mm:ss',
            monthFormat: 'MMMM',
            monthBeforeYear: true,
            previousMonth: 'Mese precedente (PageUp)',
            nextMonth: 'Il mese prossimo  (PageDown)',
            previousYear: "All'anno precedente (Control + left)",
            nextYear: 'Il prossimo anno  (Control + right)',
            previousDecade: 'Precedente decennio',
            nextDecade: 'Prossimo decennio',
            previousCentury: 'Secolo precedente',
            nextCentury: 'Dopo secolo',

            placeholder: 'Selezionare una data',
            rangePlaceholder: ['Data di inizio', 'Data di fine'],
        },
    },
};
